import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

import Landing from '@/components/Landing';
import Makes from '@/components/Makes';

const routes = [
    {
        path: '/',
        name: 'Landing',
        component: Landing,
        alias: '/demo'
    }, {
        path: '/about',
        name: 'About',
        component: Landing
    }, {
        path: '/contact',
        name: 'Contact',
        component: Landing
    }, {
        path: '/makes/:slug',
        name: 'Makes',
        component: Makes
    }
];

const router = new VueRouter({
    routes,
    mode: 'history',
    base: '/'
});

export default router;